import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import LoginCarousel from './LoginCarousel';
import { userActions } from '../../_actions';
import './auth.css';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      email: '',
      emailError: '',
      error: '',
      isLoading: false,
      success: false
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ 
      [name]: value,
      [`${name}Error`]: '',
      error: ''
    });
  }

  validateEmail(email) {
    const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(email);
  }

  handleSubmit(e) {
    e.preventDefault();
    
    const { email } = this.state;
    
    // Validation
    if (!email) {
      this.setState({ emailError: 'Please enter your email address' });
      return;
    }
    
    if (!this.validateEmail(email)) {
      this.setState({ emailError: 'Please enter a valid email address' });
      return;
    }

    this.setState({ isLoading: true });

    const params = {
      email: email.toLowerCase(),
      deviceToken: 'web',
      deviceTypeId: 2
    };

    this.props.dispatch(userActions.forgot(params))
      .then((response) => {
        this.setState({ isLoading: false });
        
        if (response.data.errorCode === 0 || response.data.statusCode === 1) {
          this.setState({ success: true });
        } else {
          this.setState({
            error: response.data.messages || response.data?.error?.errorMessage || 'Failed to send reset email. Please try again.'
          });
        }
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          error: 'An error occurred. Please try again.'
        });
      });
  }

  renderSuccessView() {
    return (
      <div className="auth-form-container auth-centered">
        <div className="auth-success-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
            <circle cx="32" cy="32" r="32" fill="#007EA0" fillOpacity="0.08"/>
            <path d="M22 32L28 38L42 24" stroke="#007EA0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h2 className="auth-title">Check your email</h2>
        <p className="auth-subtitle">
          We've sent a password reset link to <strong>{this.state.email}</strong>
        </p>

        <p className="auth-helper-text">
          Didn't receive the email? Check your spam folder or try again.
        </p>

        <Link to="/login" className="auth-button auth-button-primary" style={{ textDecoration: 'none' }}>
          Back to Login
        </Link>

        <div className="auth-footer-link">
          <button
            onClick={() => this.setState({ success: false, email: '', error: '' })}
            className="auth-link"
          >
            Try a different email
          </button>
        </div>
      </div>
    );
  }

  renderFormView() {
    const { email, emailError, error, isLoading } = this.state;

    return (
      <div className="auth-form-container">
        <div className="auth-top-row">
          <Link to="/login" className="auth-nav-back">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
          <div className="auth-logo">
            <img
              src={require('../../assets/images/loginLogo.png')}
              alt="Beu Logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
          <div className="auth-top-row-spacer" />
        </div>

        <h2 className="auth-title">Forgot your password?</h2>
        <p className="auth-subtitle">
          No worries! Enter your email and we'll send you reset instructions.
        </p>

        {error && (
          <div className="auth-error auth-mb-md">
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={this.handleSubmit}>
          <div className="auth-form-group">
            <label className="auth-label">Email Address</label>
            <input
              type="email"
              name="email"
              className={`auth-input ${emailError ? 'error' : ''}`}
              placeholder="you@example.com"
              value={email}
              onChange={this.handleChange}
              autoComplete="email"
            />
            {emailError && (
              <div className="auth-error">
                <span>{emailError}</span>
              </div>
            )}
          </div>

          <button
            type="submit"
            className="auth-button auth-button-primary"
            disabled={isLoading}
          >
            {isLoading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-divider">
          <span>or</span>
        </div>

        <div className="auth-footer-link">
          <span className="auth-text-muted">Remember your password? </span>
          <Link to="/login" className="auth-link">
            Sign in
          </Link>
        </div>
      </div>
    );
  }

  render() {
    const { success } = this.state;

    return (
      <AuthLayout rightPanel={<LoginCarousel />}>
        {success ? this.renderSuccessView() : this.renderFormView()}
      </AuthLayout>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps)(ForgotPassword);